export type WithSeconds = { seconds: number; _seconds?: never };
export type WithUnderscoreSeconds = { _seconds: number; seconds?: never };

export type SerializedFirebaseTimestamp = WithSeconds | WithUnderscoreSeconds;

export function isWithSeconds(
  value: SerializedFirebaseTimestamp
): value is WithSeconds {
  return 'seconds' in value;
}